import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';

const app = new modular({
    modules: modules
});

//debug
const isDebug = (html.dataset.debug == 'true') ? true : false
window.isDebug = isDebug;

window.onload = (event) => {
    const $style = document.getElementById('main-css');

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
};

function init() {
    globals();

    app.init(app);

    // Debug focus
    if(isDebug) {
        document.addEventListener('focusin', function() {
            console.log('focused: ', document.activeElement)
        }, true);
    }

    setTimeout(() => {
        html.classList.add('is-first-hit');
        html.classList.add('is-loaded');
        html.classList.add('is-ready');
        html.classList.remove('is-loading');
    }, 500);
}
